import { TooltipComponent, SvgIcon } from '@salecycle/ui-component-library';
import styled from 'styled-components';
import { Badge, IProps } from '@salecycle/ui-component-library/Badge/Badge';
import { FC } from 'react';

export interface ISegmentItemBadgeProps extends IProps {
  tooltip?: string;
  tooltipColor?: string;
  dataTestID?: string;
  color?: string;
}

export const SegmentItemBadge: FC<ISegmentItemBadgeProps> = props => (
  <>
    <StyledMargin>
      <Badge dataTestID={props.dataTestID} variation="basic" color={props.color} rounded={4} {...props}>
        {props.children}
      </Badge>
      <StyledInlineVertical>
        {props.tooltip && (
          <TooltipComponent label={props.tooltip} position="Right">
            <SvgIcon id="circle-question" name="circle-question" color={props.tooltipColor} />
          </TooltipComponent>
        )}
      </StyledInlineVertical>
    </StyledMargin>
  </>
);

const StyledMargin = styled.div`
  padding: ${({ theme }) => theme.designToken.spacing1};
`;

const StyledInlineVertical = styled.div`
  display: inline-block;
  padding-left: ${({ theme }) => theme.designToken.spacing1};
`;

export default SegmentItemBadge;
